// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#seasidetms_fb_czot0nn2x{padding-top:0;padding-bottom:0;border-radius:5px;background-color:#ddd;background-image:url(/img/equipment.jpg);background-position:50%;background-repeat:no-repeat;background-attachment:scroll;background-size:cover}#seasidetms_fb_czot0nn2x .featured_block_inner{width:37%;padding:4% 40px 3% 5%;text-align:left;float:left;background-color:hsla(0,0%,100%,.95)}#seasidetms_fb_czot0nn2x .featured_block_text{text-align:left}", ""]);
// Exports
module.exports = exports;
